import { useMessages } from '@/base/app';

export function useCompletedToCreatePlayground(emit: (name: string) => void) {
  function signIn() {
    emit('sign-in');
  }
  const msgs = useMessages({ prefix: 'playground.molecules.completedToCreatePlayground' });
  return { labelStart: msgs.of('start'), message: msgs.of('message'), signIn };
}
